<template lang="pug">
  section(class="hero is-large")
    b-modal(v-model="showVendorModal")
      ModifyVendor(v-bind:fromModal="true" v-on:vendor-added="getVendors")
    
    div(class="hero-body has-text-centered")
      div(class="container")

        div(v-if="step === 1")
          div(class="columns is-centered")
            div(class="column is-half")
              h1(class="title") Which ingredient are we adding?
              b-field(label="INGREDIENT")
                b-input(placeholder="Enter Ingredient Name" v-model="ingredient.name" rounded)
              div(class="field is-grouped is-grouped-centered")
                p(class="control")
                  b-button(type="is-primary is-rounded" @click="incrementStep" :disabled="!isNameComplete") 
                    strong Next

        div(v-if="step === 2")
          div(class="columns is-centered")
            div(class="column is-half")
              h1(class="title") What is the price?
              div(class="columns" v-for="price in ingredient.prices" position="is-centered")
                div(class="column")
                  b-field(label="PRICE")
                    b-input(placeholder="Enter Price" icon="dollar-sign" v-model="price.price" rounded)
                div(class="column")
                  b-field(label="QUANTITY")
                    b-input(placeholder="Enter Quantity" v-model="price.quantity" rounded)
                div(class="column")
                  b-field(label="UOM")
                    b-select(placeholder="Select UOM" v-model="price.unit" expanded rounded)
                      option(v-for="unit in ingredientUnits") 
                        div {{ unit.name }} {{ unit.abbreviation ? '(' + unit.abbreviation + ')' : '' }}
              div(class="field is-grouped is-grouped-centered")
                p(class="control")
                  b-button(type="is-primary-light is-rounded" @click="decrementStep") 
                    strong Back
                p(class="control")
                  b-button(type="is-primary is-rounded" @click="incrementStep" :disabled="!isPriceComplete") 
                    strong Next

        div(v-if="step === 3")
          div(class="columns is-centered")
            div(class="column is-half")
              h1(class="title") Which country of orgin is this ingredient?
              b-field(label="COUNTRY" position="is-centered")
                b-select(placeholder="Enter Country" v-model="ingredient.country" expanded rounded)
                  option(v-for="country in countries") {{ country }}
              div(class="field is-grouped is-grouped-centered")
                p(class="control")
                  b-button(type="is-primary-light is-rounded" @click="decrementStep") 
                    strong Back
                p(class="control")
                  b-button(type="is-primary is-rounded" @click="incrementStep" :disabled="!isCountryComplete") 
                    strong Next

        div(v-if="step === 4")
          div(class="columns is-centered")
            div(class="column is-half")
              h1(class="title") Select characteristics of this ingredient
              b-field(class="has-text-left" v-for="characteristic in characteristics" :key="characteristic.key")
                b-checkbox(v-model="ingredient.characteristics" :native-value="characteristic.key") {{ characteristic.value }}
              div(class="field is-grouped is-grouped-centered")
                p(class="control")
                  b-button(type="is-primary-light is-rounded" @click="decrementStep") 
                    strong Back
                p(class="control")
                  b-button(type="is-primary is-rounded" @click="incrementStep") 
                    strong Next

        div(v-if="step === 5")
          div(class="columns is-centered")
            div(class="column is-half")
              h1(class="title") Select all product lines assciated with this ingredient
              b-field(class= "has-text-left" v-for="productLine in productLines" :key="productLine.id" )
                b-checkbox(v-model="ingredient.productLines" :native-value="productLine.id") {{ productLine.name }}
              div(class="field is-grouped is-grouped-centered")
                p(class="control")
                  b-button(type="is-primary-light is-rounded" @click="decrementStep") 
                    strong Back
                p(class="control")
                  b-button(type="is-primary is-rounded" @click="incrementStep") 
                    strong Next

        div(v-if="step === 6")
          div(class="columns is-centered")
            div(class="column is-half")
              h1(class="title") Select your vendor
              b-field(label="VENDOR" position="is-centered" grouped)
                b-select(placeholder="Enter Vendor" v-model="ingredient.vendor" expanded rounded)
                  option(v-for="vendor in vendors"
                      :value="vendor.id"
                      :key="vendor.id") {{ vendor.name }}
                b-button(type="is-primary is-rounded" @click="showVendorModal = true")
                  p(class="control")
                    strong Add New Vendor
              b-field(label="VENDOR PRODUCT CODE")
                b-input(placeholder="Enter Vendor Product Code" v-model="ingredient.vendorProductCode" rounded)
          div(class="field is-grouped is-grouped-centered")
            p(class="control")
              b-button(type="is-primary-light is-rounded" @click="decrementStep") 
                strong Back
            p(class="control")
              b-button(type="is-primary is-rounded" @click="saveIngredient" :disabled="!isVendorComplete") 
                strong Save
</template>

<script>
import ingredientUnits from '../../constants/ingredientUnits'
import ModifyVendor from '@/components/vendor/ModifyVendor.vue'
import firebase from 'firebase/app';
import 'firebase/firestore';
import { mapGetters } from "vuex";

const db = firebase.firestore();

export default {
  name: 'IngredientGuide',
  components: {
    ModifyVendor
  },
  props: {
    inputIngredient: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
    isNameComplete() {
      return this.ingredient.name
    },
    isPriceComplete() {
      return this.ingredient.prices[0].price && 
        this.ingredient.prices[0].quantity && 
        this.ingredient.prices[0].unit
    },
    isCountryComplete() {
      return this.ingredient.country
    },
    isVendorComplete() {
      return this.ingredient.vendor
    }
  },
  data() {
    return {
      ingredientUnits: ingredientUnits,
      showVendorModal: false,
      ingredient: {
        name: '',
        vendorProductCode: '',
        prices: [
          {
            price: '',
            quantity: '',
            unit: null
          },
        ],
        country: null,
        characteristics: [],
        productLines: []
      },
      productLines: [],
      vendors: [],
      step: 1,
      countries: [
        'United States', 'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua & Deps', 'Argentina', 'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Central African Rep', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Congo {Democratic Rep}', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland {Republic}', 'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea North', 'Korea South', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar {Burma}', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russian Federation', 'Rwanda', 'St Kitts & Nevis', 'St Lucia', 'Saint Vincent & the Grenadines', 'Samoa', 'San Marino', 'Sao Tome & Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad & Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
      ],
      characteristics: [ {
        key: 'organic',
        value: 'Organic'
      },
      {
        key: 'glutenFree',
        value: 'Gluten-Free'
      },
      {
        key: 'kosher',
        value: 'Kosher'
      },
      {
        key: 'sustainablyAndRegenerativlySourced',
        value: 'Sustainably & Regenerativly Sourced'
      },
      {
        key: 'directFromFarmer',
        value: 'Direct From Farmer'
      }]
    }
  },
  mounted () {
    this.getVendors();
    this.getProductLines();
    this.initalizeIngredient();
  },
  methods: {
    initalizeIngredient() {
      if (this.inputIngredient != null) {
        this.ingredient = { ...this.inputIngredient }
      }
      if (this.ingredient.characteristics === undefined) {
        this.ingredient.characteristics = []
      }
      if (this.ingredient.productLines === undefined) {
        this.ingredient.productLines = []
      }
    },
    incrementStep() {
      this.step = this.step + 1
    },
    decrementStep() {
      this.step = this.step - 1
    },
    getVendors() {
      this.vendors = [];
      db.collection("vendors")
        .where("organizationId", "==", this.user.data.organizationId)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let vendor = doc.data()
            vendor.id = doc.id
            this.vendors.push(vendor)
          })
        })
        .catch(() => {
        this.$buefy.toast.open({
        message: 'There was a problem getting vendors.',
        type: 'is-danger',
        duration: 5000});
      });
    },
    getProductLines() {
      db.collection("product-lines")
        .where("organizationId", "==", this.user.data.organizationId)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let productLine = doc.data()
            productLine.id = doc.id
            this.productLines.push(productLine)
          })
        })
    },
    saveIngredient() {
      this.ingredient.organizationId = this.user.data.organizationId

      if(this.inputIngredient == null) {
        db.collection("ingredients").add({
          ...this.ingredient
      })
      .then(() => {
        this.$buefy.toast.open({
        message: 'Ingredient Saved',
        type: 'is-success',
        duration: 5000});
        this.$router.replace({ name: "Ingredients" });
      })
      .catch(() => {
        this.$buefy.toast.open({
        message: 'There was a problem saving the ingredient.',
        type: 'is-danger',
        duration: 5000});
      });
      } else {
        db.collection("ingredients").doc(this.ingredient.id).set({
          ...this.ingredient
      })
      .then(() => {
        this.$buefy.toast.open({
        message: 'Ingredient Saved',
        type: 'is-success',
        duration: 5000});
        this.$router.replace({ name: "Ingredients" });
      })
      .catch(() => {
        this.$buefy.toast.open({
        message: 'There was a problem saving the ingredient.',
        type: 'is-danger',
        duration: 5000});
      });
      }
    }
  }
}
</script>

<style lang="scss">
.titleButton {
  padding: 25px
}
</style>